<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row>
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="isExpanded(u) ? 'collapsible expanded collapsible__restriction' : 'collapsible collapsible__restriction collapsed'" v-for="(u, uindex) in preset[0].restriction" v-bind:key="'lcrbrl'+uindex">
					<div class="collapsible-heading">
						<div class="d-flex">
							<div class="collapsible-heading__image" @click="onToggleExpand(uindex)">
								<b-img :src="LaneClosureRequest.getRestrictionImage100(u.restrictionTypeId.value)" fluid style="width: 50px; height:50px;"></b-img>
							</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand(uindex)">{{LaneClosureRequest.getDirectionText(u.directionId.value)}}  {{LaneClosureRequest.getRestrictionTypeText(u.restrictionTypeId.value)}} <small v-html="getTitleText(uindex)"></small><br/><small v-html="getPeakReasonText(uindex)"></small><br/></div>
							<div class="collapsible-heading__review-blocks" @click="onToggleExpand(uindex)"><div class="flex-table"><div class="flex-table-cell">Review Blocks</div></div></div>
							<div class="collapsible-heading__toggle">
								<div class="flex-table">
								<b-button href="#" variant="collapsible" :class="isExpanded(u) ? ' flex-table-cell' : ' collapsed flex-table-cell'" :aria-expanded="isExpanded(u) ? 'true' : 'false'" :aria-controls="'collapseRestrictionListing'+uindex" @click="onToggleExpand(uindex)">
									<span class="when-opened">
										<font-awesome-icon icon="chevron-down" />
									</span>
									<span class="when-closed">
										<font-awesome-icon icon="chevron-right" />
									</span>
								</b-button>
								</div>
							</div>
							<button type="button" class="collapsible-heading__remove" title="Remove Turning Restriction" @click="onRemoveAll(uindex)"><font-awesome-icon icon="trash" /></button>

						</div>
					</div>
						<b-collapse :id="'collapseRestrictionListing'+uindex" :visible="isExpanded(u)" class="collapsible-entries">
							<div class="collapsible-entries__wrapper">
								<div :class="classes(b2index,uindex)" v-for=" (b, b2index) in value" v-if="canBeAdded(b2index, uindex)" :key="'eblr2index'+b2index+'-'+uindex+'-'+renderCounter">
									<div class="d-flex collapsible-entry">
										<div class="collapsible-entry__icon"><b-img :src="LaneClosureRequest.getRestrictionImage(u.restrictionTypeId.value)"></b-img></div>
										<div class="collapsible-entry__title flex-grow-1">
											<a href="#" @click="showOnMap(b.blockId, u)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <strong>{{b.fromStreet.value}}</strong> and <strong>{{b.toStreet.value}}</strong>, {{LaneClosureRequest.getRestrictionTypeText(u.restrictionTypeId.value)}} on to </a>
										</div>
										<div class="text-right">
										<b-dropdown variant="text" :id="'dropdownRestriction'+b2index+renderCounter" :text="'Add'" class="mr-2 mt-1">
											<b-dropdown-item v-for="(l2, l2index) in dropdownCrossStreetOptions(b2index, uindex)" :key="'blr2lindex'+l2index+renderCounter" @click="onAddBlock(b2index,uindex,l2.value)">
												{{l2.value}}
											</b-dropdown-item>
										</b-dropdown>
										</div>
										<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId, u)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
									</div>
										<div class="d-flex collapsible-entry collapsible-entry__restriction-turn-entry" v-for="(l2, l2index) in crossStreetOptions(b2index, uindex)" :key="'blr2lindex'+l2index+renderCounter">
											<div v-if="!l2.list" class="flex-grow-1 collapsible-entry__restriction-turn__street text-right">{{l2.value}}</div>
											<div v-if="l2.value" class="collapsible-entry__switch">
											<div class="restricting-off-switch-field">
													<input :id="switchId('eblrestriction',b2index,uindex,u.restrictionTypeId.value,l2index)"  class="restricting-off-switch" :checked="isEntry(b2index,uindex,l2.value)" type="checkbox" @change="toggleRemoveBlock(b2index,uindex,l2.value)" >
													<label :for="switchId('eblrestriction',b2index,uindex,u.restrictionTypeId.value,l2index)"></label>
											</div>
											</div>
											<div class="collapsible-entry__delete-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="onRemoveBlock(b2index,uindex,l2.value)"><span class="icon-trash"></span></b-button></div>
										</div>
								</div>
								<div class="is-not-entry">
										<div class="d-flex collapsible-entry">
											<div class="collapsible-entry__icon"><b-img :src="LaneClosureRequest.getRestrictionImage(u.restrictionTypeId.value)"></b-img></div>
											<div class="collapsible-entry__set-all-blocks flex-grow-1">Need to add or remove a street block from this request? Open the  map <b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button> and click on the street or block.</div>
										<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
										</div>
								</div>

							</div>
						</b-collapse>
							</div>

						<div v-if="$store.state.isMobile" :class="isExpanded(u) ? 'collapsible expanded' : 'collapsible collapsed'" v-for="(u, uindex) in preset[0].restriction" v-bind:key="'lcrbrl'+uindex">
							<div class="collapsible-heading">
								<div class="d-flex">
									<div class="collapsible-heading__image" @click="onToggleExpand(uindex)">
										<b-img :src="LaneClosureRequest.getRestrictionImage100(u.restrictionTypeId.value)" style="width: 50px; height:50px;"></b-img>
									</div>
									<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand(uindex)">{{LaneClosureRequest.getDirectionText(u.directionId.value)}}  {{LaneClosureRequest.getRestrictionTypeText(u.restrictionTypeId.value)}} <div class="collapsible-heading__subtitle" v-html="getPeakReasonTextMobile(uindex)"></div><div class="collapsible-heading__subtitle" v-html="getTitleText(uindex)"></div></div>
									<div class="collapsible-heading__toggle">
										<div class="flex-table">
										<b-button href="#" variant="collapsible" :class="isExpanded(u) ? ' flex-table-cell' : ' collapsed flex-table-cell'" :aria-expanded="isExpanded(u) ? 'true' : 'false'" :aria-controls="'collapseRestrictionListing'+uindex" @click="onToggleExpand(uindex)">
											<span>
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
										</div>
									</div>
									<button type="button" class="collapsible-heading__remove" title="Remove Turning Restriction" @click="onRemoveAll(uindex)"><font-awesome-icon icon="trash" /></button>

								</div>
							</div>
						</div>
						<div v-if="$store.state.isMobile">
							<transition name="slide-fade" tag="div" >
								<div class="d-block section-slide-panel" v-if="showPanel">
									<div class="top-controls">
										<button type="button" @click="onSwipeRight">
											<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
										</button>
									</div>
									<div class="panels-body edit-lcr-panels-body panels-body-padded panels-no-menu">
									<div class="panels-nav-title" v-html="getNavTitle"></div>
									<div v-if="isExpanded(u)" v-for="(u, uindex) in preset[0].restriction" v-bind:key="'lcrbrl'+uindex">
										<div class="panels-body-title">
											<b-img :src="LaneClosureRequest.getRestrictionImage100(u.restrictionTypeId.value)" style="width: 50px; height:50px;"></b-img>
											<div class="flex-grow-1" @click="onToggleExpand(uindex)">{{LaneClosureRequest.getDirectionText(u.directionId.value)}}  {{LaneClosureRequest.getRestrictionTypeText(u.restrictionTypeId.value)}} <div class="panels-body-subtitle"  v-html="getTitleText(uindex)"></div></div>
										</div>
										<div class="panels-body-content">
											<div class="panels-body-content__peak-reason" v-html="getPeakReasonText(uindex)"></div>


											<div class="is-entry" v-for=" (b, b2index) in value" v-if="canBeAdded(b2index, uindex)" :key="'dddeblr2index'+b2index+'-'+uindex+'-'+renderCounter">
												<div class="d-flex collapsible-entry">
													<div class="collapsible-entry__title flex-grow-1">
														<a href="#" @click="showOnMap(b.blockId, u)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <strong>{{b.fromStreet.value}}</strong> and <strong>{{b.toStreet.value}}</strong>, {{LaneClosureRequest.getRestrictionTypeText(u.restrictionTypeId.value)}} on to </a>
													</div>
													<div class="text-right">
													<b-dropdown variant="text" :id="'dropdownRestriction'+b2index+renderCounter" :text="'Add'" class="mr-2 mt-1">
														<b-dropdown-item v-for="(l2, l2index) in dropdownCrossStreetOptions(b2index, uindex)" :key="'blr2lindex'+l2index+renderCounter" @click="onAddBlock(b2index,uindex,l2.value)">
															{{l2.value}}
														</b-dropdown-item>
													</b-dropdown>
													</div>
													<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId, u)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
												</div>
													<div class="d-flex collapsible-entry collapsible-entry__restriction-turn-entry" v-for="(l2, l2index) in crossStreetOptions(b2index, uindex)" :key="'blr2lindex'+l2index+renderCounter">
														<div v-if="!l2.list" class="flex-grow-1 collapsible-entry__restriction-turn__street text-right">{{l2.value}}</div>
														<div v-if="l2.value" class="collapsible-entry__switch">
														<div class="restricting-off-switch-field">
																<input :id="switchId('eblrestriction',b2index,uindex,u.restrictionTypeId.value,l2index)"  class="restricting-off-switch" :checked="isEntry(b2index,uindex,l2.value)" type="checkbox" @change="toggleRemoveBlock(b2index,uindex,l2.value)" >
																<label :for="switchId('eblrestriction',b2index,uindex,u.restrictionTypeId.value,l2index)"></label>
														</div>
														</div>
														<div class="collapsible-entry__delete-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="onRemoveBlock(b2index,uindex,l2.value)"><span class="icon-trash"></span></b-button></div>
													</div>
											</div>
											<div class="is-entry">
													<div class="d-flex collapsible-entry">
														<div class="collapsible-entry__set-all-blocks flex-grow-1">Need to add or remove a street block from this request? Open the  map <b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button> and click on the street or block.</div>
													<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
													</div>
											</div>
									</div>
									<div class="panels-apply">
										<div class="d-flex">
											<div class="panels-apply__close"><b-button @click="setAllYes(uindex)" variant="light" class="close-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />Restrict</b-button></div>
											<div class="panels-apply__open"><b-button @click="setAllNo(uindex)" variant="light" class="open-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />Allow</b-button></div>
											<div class="panels-apply__save"><b-button @click="onApply(uindex)" variant="secondary" class="save-button" type="button"><span class="btn__icon"><img src="/img/assets/icon-checkmark-blue.svg"/></span><span class="btn__text">Apply</span></b-button></div>
										</div>
										</div>
									</div>
									<div v-if="!somethingExpanded" class="panels-apply">
										<div class="d-flex">
											<div class="panels-apply__close"><b-button @click="setAllYes(uindex)" variant="light" class="close-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />Restrict</b-button></div>
											<div class="panels-apply__open"><b-button @click="setAllNo(uindex)" variant="light" class="open-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />Allow</b-button></div>
											<div class="panels-apply__save"><b-button @click="onApply(uindex)" variant="secondary" class="save-button" type="button"><span class="btn__icon"><img src="/img/assets/icon-checkmark-blue.svg"/></span><span class="btn__text">Apply</span></b-button></div>
										</div>
									</div>
								</div>
								</div>
							</transition>
						</div>

				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'

import Vue from 'vue'

export default {
	name: 'LaneClosureRequestBlockRestrictionListing',
	props: ['value', 'preset','expand', 'renderCounter'],
	data() {
		return {
			isEditing: false,
			editingIndex: null,
			LaneClosureRequest: LaneClosureRequest,
			backupBlock: null,
			errorMsg: null,
			lastIndex: null,
			backup: {},
			showPanel:false,
			somethingExpanded:false,
		}
	},
	mounted() {
		this.showPanel = this.expand;
		Vue.prototype.$bus.$on('swipe:right:panel', this.onSwipeRight);
     },
     destroyed() {
		Vue.prototype.$bus.$off('swipe:right:panel', this.onSwipeRight);
     },
    watch: {
   	'$store.state.isMobile' : function() {
   		this.showPanel = false;
   	},

   },
	computed: {
		getNavTitle() {
			return "Select Blocks to Restrict";
		},
	},
	methods: {
		getExpandClasses(obj) {
			if (obj) {
				if (obj.expand) {
					return "collapsible expanded collapsible__restriction";
				}
			}
			return "collapsible collapsible__restriction collapsed";
		},
		isExpanded(u) {
			if (u) {
				if (typeof u.expand != "undefined") {
					if (u.expand) {
						this.somethingExpanded = true;
					}
					return u.expand;

				}
			}
			this.somethingExpanded = false;
			return false;
		},
		classes: function(index,uindex, streetName) {
			if (this.hasRestriction(index,uindex)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		getTitleText(uindex) {
			let title = "";
			let qty = 0;
			let total = 0;
			let found = false;
			if (this.value) {
				for (var xx = 0; xx < this.value.length; xx++) {
					found = false;
					for (var x = 0; x < this.value[xx].restriction.length; x++) {
						if (
						this.value[xx].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
						this.value[xx].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
						this.value[xx].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId.value
						) {
							found = true;
						}
					}
					if (this.canBeAdded(xx,uindex)) {
						total++;
					}
					if (found) {
						qty++;
					}
				}
			}
			let blockText = "blocks";
			if (this.value.length == 1) {
				blockText = "block";
			}
			if (qty > total) {
				qty = total;
			}

			if (qty == 1) {
				title = qty + " of " + total + " " + blockText;
			} else {
				if (qty == 0) {
					title = "<span class='no-blocks-assigned'>set blocks to restrict</span>";
				} else {
					title = qty + " of " + total + " " + blockText;
				}
			}
			if (qty == total) {
				title = "all blocks";
			}
			if (this.$store.state.isMobile || qty == 0) {
				return title;
			} else {
				return " ("+title+")";
			}
		},


		getPeakReasonText(index) {
			let html = "";
			if (this.value) {

				if (this.preset[0].restriction[index]) {
					html = LaneClosureRequest.getRestrictionPeakIdText(this.preset[0].restriction[index].peakId.value);
					if (this.preset[0].restriction[index].peakId.value == 6 || this.preset[0].restriction[index].peakId.value == 13 || this.preset[0].restriction[index].peakId.value == 19) {
						html += "<br/>" + this.preset[0].restriction[index].peakReason.value;
					}
				}
			}
			return html;
		},
		getPeakReasonTextMobile(index) {
			let html = "";
			if (this.value) {
				if (this.preset[0].restriction[index]) {
					let reusltText = "";
					const peakShortTexts = LaneClosureRequest.getRestrictionPeakReasonShort;
					peakShortTexts.forEach(x => {
						if (x.ids.includes(this.preset[0].restriction[index].peakId.value)) {
							reusltText = x.text;
						}
					});

					html += reusltText;
				}
			}

			return html;
		},
		hasEntries: function(uindex) {
			if (this.value) {
				for (var index = 0; index < this.value.length; index++) {
					for (var x = 0; x < this.value[index].restriction.length; x++) {
						if (this.preset[0].restriction[uindex]) {
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.preset[0].restriction[uindex].restrictionTypeId == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId &&
								this.value[index].restriction[x].peakReason.value == this.preset[0].restriction[uindex].peakReason
							) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},
		hasRestriction: function(index, uindex) {
			if (this.value) {
				if (this.preset[0].restriction[uindex]) {
					if (this.value[index]) {
						for (var x = 0; x < this.value[index].restriction.length; x++) {
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId.value
							) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},

		isEntry: function(index, uindex, streetName) {
			if (this.value) {
				if (this.preset[0].restriction[uindex]) {
					if (this.value[index]) {
						for (var x = 0; x < this.value[index].restriction.length; x++) {
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId.value &&
								this.value[index].restriction[x].crossStreet.value == streetName

							) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},

		isSelectedStreetOptionsEntry: function(index, uindex, streetName) {
			if (this.value) {
				if (this.preset[0].restriction[uindex]) {
					if (this.value[index]) {
						for (var x = 0; x < this.value[index].restriction.length; x++) {
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId.value &&
								this.value[index].restriction[x].crossStreet.value == streetName

							) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},

		canBeAdded: function(index, uindex) {
			if (this.value) {
				if (this.preset[0].restriction[uindex]) {
					if (this.value[index]) {
						for (var x = 0; x < this.value[index].restriction.length; x++) {
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId
							) {
								return true;
							}
						}
					}
				}
			}
			if (LaneClosureRequest.areDirectionsEquivalent(this.preset[0].restriction[uindex].directionId.value,this.value[index].directionId)) {
				return true;
			}
			return false;
		},

		hasBeenAdded: function(index, uindex) {
			if (this.value) {
				if (this.preset[0].restriction[uindex]) {
					if (this.value[index]) {
						for (var x = 0; x < this.value[index].restriction.length; x++) {
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId
							) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},


		// isAnyEntry: function(index) {
		// 	if (this.value) {
		// 		if (this.value[index]) {
		// 			for (var x = 0; x < this.value[index].restriction.length; x++) {
		// 				if (
		// 				this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value
		// 				) {
		// 					return true;
		// 				}
		// 			}
		// 		}
		// 	}
		// 	return false;
		// },

		selectedStreetOptionsEntry: function(x, uindex) {
			if (this.value[x].turningStreetName.length > 0) {
				for (var xx = 0; xx < this.value[x].turningStreetName.length; xx++) {
					if (this.isEntry(x,uindex,this.value[x].turningStreetName[xx])) {
						return  x+"__" +uindex+"__" + this.value[x].turningStreetName[xx];
					}
				}
			}
			return null;
		},

		selectedStreetOptionsValue: function(x, uindex) {
			if (this.value[x].turningStreetName.length > 0) {
				for (var xx = 0; xx < this.value[x].turningStreetName.length; xx++) {
					if (this.isEntry(x,uindex,this.value[x].turningStreetName[xx])) {
						return  this.value[x].turningStreetName[xx];
					}
				}
			}
			return null;
		},

		onSelectedStreetOptionsEntry: function(value) {
			// console.log(value);
			// x, uindex, street

		},


		dropdownCrossStreetOptions: function(x, uindex) {
			// No Left Turn
			var crossStreet = null;
			// var hasTurns = false;
			let options = [];
			// var val = [];
			// var y =0;

			if (this.value[x].directionId != null) {
				// if (
				// this.value[x].northboundLeft != null ||
				// this.value[x].northboundRight != null ||
				// this.value[x].northboundThrough != null ||
				// this.value[x].southboundLeft != null ||
				// this.value[x].southboundRight != null ||
				// this.value[x].southboundThrough != null ||
				// this.value[x].eastboundLeft != null ||
				// this.value[x].eastboundRight != null ||
				// this.value[x].eastboundThrough != null ||
				// this.value[x].westboundLeft != null ||
				// this.value[x].westboundRight != null ||
				// this.value[x].westboundThrough != null
				// ) {
				// 	hasTurns = true;
				// }
				if (this.preset[0].restriction[uindex].restrictionTypeId.value == 1) {
					// Northbound
					if (this.preset[0].restriction[uindex].directionId.value == 1 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].northboundLeft;
					}
					// Southbound
					if (this.preset[0].restriction[uindex].directionId.value == 2 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].southboundLeft;
					}
					// Eastbound
					if (this.preset[0].restriction[uindex].directionId.value == 3 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].eastboundLeft;
					}
					// Westbound
					if (this.preset[0].restriction[uindex].directionId.value == 4 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].westboundLeft;
					}
				}
				// No Right Turn
				if (this.preset[0].restriction[uindex].restrictionTypeId.value == 2) {
					// Northbound
					if (this.preset[0].restriction[uindex].directionId.value == 1 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].northboundRight;
					}
					// Southbound
					if (this.preset[0].restriction[uindex].directionId.value == 2 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].southboundRight;
					}
					// Eastbound
					if (this.preset[0].restriction[uindex].directionId.value == 3 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].eastboundRight;
					}
					// Westbound
					if (this.preset[0].restriction[uindex].directionId.value == 4 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].westboundRight;
					}
				}
				// No Through
				if (this.preset[0].restriction[uindex].restrictionTypeId.value == 3) {
					// Northbound
					if (this.preset[0].restriction[uindex].directionId.value == 1 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].northboundThrough;
					}
					// Southbound
					if (this.preset[0].restriction[uindex].directionId.value == 2 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].southboundThrough;
					}
					// Eastbound
					if (this.preset[0].restriction[uindex].directionId.value == 3 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].eastboundThrough;
					}
					// Westbound
					if (this.preset[0].restriction[uindex].directionId.value == 4 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].westboundThrough;
					}
				}

				if (crossStreet != "" && crossStreet != null) {
					options.push({ value:crossStreet, text:crossStreet, xIndex:x, uIndex:uindex });
				}
				// we don't have a direction... so let's use the TurningStreetNames
			}
			// provide all options to the user, plus Other.
			if (this.value[x].turningStreetName.length > 0) {
				for (var xx = 0; xx < this.value[x].turningStreetName.length; xx++) {
					if (this.value[x].turningStreetName[xx] != crossStreet) {
						options.push({ value:this.value[x].turningStreetName[xx], text:this.value[x].turningStreetName[xx]});
					}
				}
			}
			options.push({ value:"Backlane", text:"Backlane"});
			options.push({ value:"Parking Lot", text:"Parking Lot"});
			options.push({ value:"Other", text:"Other",});


			if (options.length == 0) {
				return null;
			}
			return options;
		},

		crossStreetOptions: function(x, uindex) {
			// No Left Turn
			let options = [];
			let y = 0;
			if (typeof this.preset[0].restriction[uindex].turningStreetName["b"+ this.value[x].blockId] != "undefined") {
				for (y = 0; y < this.preset[0].restriction[uindex].turningStreetName["b"+ this.value[x].blockId].length; y++) {
						if (this.preset[0].restriction[uindex].turningStreetName["b"+ this.value[x].blockId][y] != null) {
							options.push({ value:this.preset[0].restriction[uindex].turningStreetName["b"+ this.value[x].blockId][y], text:this.preset[0].restriction[uindex].turningStreetName["b"+ this.value[x].blockId][y]});
						}
				}
			}
			return options;

			/*
			var crossStreet = null;
			var hasTurns = false;
			var val = [];
			this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId][x]

			if (this.value[x].directionId != null) {

				if (
				this.value[x].northboundLeft != null ||
				this.value[x].northboundRight != null ||
				this.value[x].northboundThrough != null ||
				this.value[x].southboundLeft != null ||
				this.value[x].southboundRight != null ||
				this.value[x].southboundThrough != null ||
				this.value[x].eastboundLeft != null ||
				this.value[x].eastboundRight != null ||
				this.value[x].eastboundThrough != null ||
				this.value[x].westboundLeft != null ||
				this.value[x].westboundRight != null ||
				this.value[x].westboundThrough != null
				) {
					hasTurns = true;
				}



				if (this.preset[0].restriction[uindex].restrictionTypeId.value == 1) {
					// Northbound
					if (this.preset[0].restriction[uindex].directionId.value == 1 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].northboundLeft;
					}
					// Southbound
					if (this.preset[0].restriction[uindex].directionId.value == 2 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].southboundLeft;
					}
					// Eastbound
					if (this.preset[0].restriction[uindex].directionId.value == 3 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].eastboundLeft;
					}
					// Westbound
					if (this.preset[0].restriction[uindex].directionId.value == 4 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].westboundLeft;
					}
				}
				// No Right Turn
				if (this.preset[0].restriction[uindex].restrictionTypeId.value == 2) {
					// Northbound
					if (this.preset[0].restriction[uindex].directionId.value == 1 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].northboundRight;
					}
					// Southbound
					if (this.preset[0].restriction[uindex].directionId.value == 2 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].southboundRight;
					}
					// Eastbound
					if (this.preset[0].restriction[uindex].directionId.value == 3 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].eastboundRight;
					}
					// Westbound
					if (this.preset[0].restriction[uindex].directionId.value == 4 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].westboundRight;
					}
				}
				// No Through
				if (this.preset[0].restriction[uindex].restrictionTypeId.value == 3) {
					// Northbound
					if (this.preset[0].restriction[uindex].directionId.value == 1 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].northboundThrough;
					}
					// Southbound
					if (this.preset[0].restriction[uindex].directionId.value == 2 || this.preset[0].restriction[uindex].directionId.value == 6) {
						crossStreet = this.value[x].southboundThrough;
					}
					// Eastbound
					if (this.preset[0].restriction[uindex].directionId.value == 3 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].eastboundThrough;
					}
					// Westbound
					if (this.preset[0].restriction[uindex].directionId.value == 4 || this.preset[0].restriction[uindex].directionId.value == 5) {
						crossStreet = this.value[x].westboundThrough;
					}
				}

				if (crossStreet != "" && crossStreet != null) {
					options.push({ value:crossStreet, text:crossStreet, xIndex:x, uIndex:uindex });
				} else {
					if (!hasTurns) {
						options.push({ value:this.value[x].fromStreet.value, text:this.value[x].fromStreet.value, xIndex:x, uIndex:uindex });
						options.push({ value:this.value[x].toStreet.value, text:this.value[x].toStreet.value, xIndex:x, uIndex:uindex});
					}
				}
				// options.push({ value:"Backlane", text:"Backlane"});
			} else {
				crossStreet = "";
				// we don't have a direction... so let's use the TurningStreetNames!
				// if (this.value[x].turningStreetName.length > 0) {
				// 	for (var xx = 0; xx < this.value[x].turningStreetName.length; xx++) {
				// 		options.push({ value:this.value[x].turningStreetName[xx].streetName, text:this.value[x].turningStreetName[xx].streetName, xIndex:x, uIndex:uindex });
				// 		// val.push({ value:this.value[x].turningStreetName[xx], text:this.value[x].turningStreetName[xx]});
				// 		// if (this.isEntry(x,uindex,this.value[x].turningStreetName[xx])) {
				// 			// crossStreet = this.value[x].turningStreetName[xx];
				// 		// }
				// 	}
				// }
				// options.push({ value:crossStreet,text:crossStreet, list:val });
			}

			// loop through the preset restriction blocks and the cross street block names... ugh.
			// this.preset[0].restriction[uindex].block[blockID].crossStreet[x]


			options.push({ value:"Backlane", text:"Backlane"});

			return options;
			*/
		},



		crossStreetBacklane: function(x, uindex) {
			// No Left Turn
			let options = [];
			options.push({ value:"Backlane", text:"Backlane"});
			return options;
		},


		crossStreetOptionsOld: function(x, uindex) {
			// No Left Turn
			var crossStreet = null;
			var hasTurns = false;
			if (
			this.value[x].northboundLeft != null ||
			this.value[x].northboundRight != null ||
			this.value[x].northboundThrough != null ||
			this.value[x].southboundLeft != null ||
			this.value[x].southboundRight != null ||
			this.value[x].southboundThrough != null ||
			this.value[x].eastboundLeft != null ||
			this.value[x].eastboundRight != null ||
			this.value[x].eastboundThrough != null ||
			this.value[x].westboundLeft != null ||
			this.value[x].westboundRight != null ||
			this.value[x].westboundThrough != null
			) {
				hasTurns = true;
			}



			if (this.preset[0].restriction[uindex].restrictionTypeId.value == 1) {
				// Northbound
				if (this.preset[0].restriction[uindex].directionId.value == 1 || this.preset[0].restriction[uindex].directionId.value == 6) {
					crossStreet = this.value[x].northboundLeft;
				}
				// Southbound
				if (this.preset[0].restriction[uindex].directionId.value == 2 || this.preset[0].restriction[uindex].directionId.value == 6) {
					crossStreet = this.value[x].southboundLeft;
				}
				// Eastbound
				if (this.preset[0].restriction[uindex].directionId.value == 3 || this.preset[0].restriction[uindex].directionId.value == 5) {
					crossStreet = this.value[x].eastboundLeft;
				}
				// Westbound
				if (this.preset[0].restriction[uindex].directionId.value == 4 || this.preset[0].restriction[uindex].directionId.value == 5) {
					crossStreet = this.value[x].westboundLeft;
				}
			}
			// No Right Turn
			if (this.preset[0].restriction[uindex].restrictionTypeId.value == 2) {
				// Northbound
				if (this.preset[0].restriction[uindex].directionId.value == 1 || this.preset[0].restriction[uindex].directionId.value == 6) {
					crossStreet = this.value[x].northboundRight;
				}
				// Southbound
				if (this.preset[0].restriction[uindex].directionId.value == 2 || this.preset[0].restriction[uindex].directionId.value == 6) {
					crossStreet = this.value[x].southboundRight;
				}
				// Eastbound
				if (this.preset[0].restriction[uindex].directionId.value == 3 || this.preset[0].restriction[uindex].directionId.value == 5) {
					crossStreet = this.value[x].eastboundRight;
				}
				// Westbound
				if (this.preset[0].restriction[uindex].directionId.value == 4 || this.preset[0].restriction[uindex].directionId.value == 5) {
					crossStreet = this.value[x].westboundRight;
				}
			}
			// No Through
			if (this.preset[0].restriction[uindex].restrictionTypeId.value == 3) {
				// Northbound
				if (this.preset[0].restriction[uindex].directionId.value == 1 || this.preset[0].restriction[uindex].directionId.value == 6) {
					crossStreet = this.value[x].northboundThrough;
				}
				// Southbound
				if (this.preset[0].restriction[uindex].directionId.value == 2 || this.preset[0].restriction[uindex].directionId.value == 6) {
					crossStreet = this.value[x].southboundThrough;
				}
				// Eastbound
				if (this.preset[0].restriction[uindex].directionId.value == 3 || this.preset[0].restriction[uindex].directionId.value == 5) {
					crossStreet = this.value[x].eastboundThrough;
				}
				// Westbound
				if (this.preset[0].restriction[uindex].directionId.value == 4 || this.preset[0].restriction[uindex].directionId.value == 5) {
					crossStreet = this.value[x].westboundThrough;
				}
			}
			let options = [];

			if (crossStreet != "" && crossStreet != null) {
				options.push({ value:crossStreet, text:crossStreet });
			} else {
				if (!hasTurns) {
					options.push({ value:this.value[x].fromStreet.value, text:this.value[x].fromStreet.value });
					options.push({ value:this.value[x].toStreet.value, text:this.value[x].toStreet.value });
				}
			}
			options.push({ value:"Backlane", text:"Backlane"});

			return options;
		},

		switchId(prefix,uindex,block,id,streetId) {
			return prefix+"-"+uindex+"-"+block+"-"+id+"-"+streetId;
		},
		shouldShowChanges(idx) {
			if (this.isEditing) {
				return true;
			}
			return false;
		},
		showOnMap: function(id, restrictionField) {
			Vue.prototype.$bus.$emit("block:show-on-map",{id, type: "restriction", laneId: restrictionField.restrictionTypeId.value});
		},
		showMap: function() {
			Vue.prototype.$bus.$emit("map:toggle", null);
			this.$store.dispatch("map/zoomAllBlocks", null);
		},

		onAddBlock: function(index, uindex, streetName) {
			if (streetName == "Other") {
				// present modal window .
				Vue.prototype.$bus.$emit("block:list-add-restriction-modal",
					{
						items:[{
					restrictionTypeId:this.preset[0].restriction[uindex].restrictionTypeId.value,
					directionId:this.preset[0].restriction[uindex].directionId.value,
					blockId:this.value[index].blockId,
					crossStreet:streetName
					,peakId:this.preset[0].restriction[uindex].peakId.value
					,peakReason: this.preset[0].restriction[uindex].peakReason.value
					,presetIndex:uindex
					,blockIndex:index
					}
						]
					}
				);
			} else {
				Vue.prototype.$bus.$emit("block:list-add-restriction",{
					items:[{
					restrictionTypeId:this.preset[0].restriction[uindex].restrictionTypeId.value,
					directionId:this.preset[0].restriction[uindex].directionId.value,
					blockId:this.value[index].blockId,
					crossStreet:streetName
					,peakId:this.preset[0].restriction[uindex].peakId.value
					,peakReason: this.preset[0].restriction[uindex].peakReason.value
					,presetIndex:uindex
				}]
				});
			}
		},


		onRemoveBlock: function(index, uindex, streetName) {
			Vue.prototype.$bus.$emit("block:list-remove-restriction-street",{
				restrictionTypeId:this.preset[0].restriction[uindex].restrictionTypeId.value,
				directionId:this.preset[0].restriction[uindex].directionId.value,
				blockId:this.value[index].blockId,
				crossStreet:streetName
				,peakId:this.preset[0].restriction[uindex].peakId.value
				,peakReason: this.preset[0].restriction[uindex].peakReason.value
				,presetIndex:uindex
			});
		},



		toggleRemoveBlock: function(index, uindex, streetName) {
			// Vue.prototype.$bus.$emit("block:list-remove-restriction",{restrictionTypeId:this.preset[0].restriction[uindex].restrictionTypeId.value,directionId:this.preset[0].restriction[uindex].directionId.value, blockId:blockId});
			if (this.isEntry(index, uindex, streetName)) {
				Vue.prototype.$bus.$emit("block:list-remove-restriction",
					{
						items:[{
					restrictionTypeId:this.preset[0].restriction[uindex].restrictionTypeId.value,
					directionId:this.preset[0].restriction[uindex].directionId.value,
					blockId:this.value[index].blockId,
					crossStreet:streetName
					,peakId:this.preset[0].restriction[uindex].peakId.value
					,peakReason: this.preset[0].restriction[uindex].peakReason.value
					,presetIndex:uindex
					,
					}]
					}
				);
			} else {
				Vue.prototype.$bus.$emit("block:list-add-restriction",{
					items:[{
					restrictionTypeId:this.preset[0].restriction[uindex].restrictionTypeId.value,
					directionId:this.preset[0].restriction[uindex].directionId.value,
					blockId:this.value[index].blockId,
					crossStreet:streetName
					,peakId:this.preset[0].restriction[uindex].peakId.value
					,peakReason: this.preset[0].restriction[uindex].peakReason.value
					,presetIndex:uindex
					}]
				});
			}
		},
		setAllYes: function(uindex) {
			Vue.prototype.$bus.$emit("preset-block:all-restrictions-in-effect",{uindex:uindex,restrictionTypeId:this.preset[0].restriction[uindex].restrictionTypeId.value,directionId:this.preset[0].restriction[uindex].directionId.value, peakId:this.preset[0].restriction[uindex].peakId.value, inEffect:1});
		},
		setAllNo: function(uindex) {
			Vue.prototype.$bus.$emit("preset-block:all-restrictions-removed",{uindex: uindex, restrictionTypeId:this.preset[0].restriction[uindex].restrictionTypeId.value,directionId:this.preset[0].restriction[uindex].directionId.value, peakId:this.preset[0].restriction[uindex].peakId.value, inEffect:0});

			// Vue.prototype.$bus.$emit("preset-block:all-restrictions-removed",{restrictionTypeId:this.restrictionTypeId,directionId:this.directionId, peakId:this.preset[0].restriction[uindex].peakId.value,inEffect:0});
		},

		onRemoveAll(uindex) {
				Vue.prototype.$bus.$emit("preset-block:remove-restriction",{index:uindex});
		},
		onApply: function(uindex) {
			this.showPanel = false;
			setTimeout(() => {
				let that = this;
				Vue.prototype.$bus.$emit("preset-block:expand-restriction",{index:uindex, expand:!that.preset[0].restriction[uindex].expand});
			}, 250);
		},


		onSwipeRight() {
			this.showPanel = false;
			setTimeout(() => {
				Vue.prototype.$bus.$emit("preset-block:collapse-restrictions");
			}, 250);
		},


		onToggleExpand(uindex) {
			this.showPanel = !this.showPanel;
			Vue.prototype.$bus.$emit("preset-block:expand-restriction",{index:uindex, expand:!this.preset[0].restriction[uindex].expand});
		},
	}
}
</script>
